/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M2.25 1.5a.75.75 0 0 1 0-1.5h19.5a.75.75 0 0 1 0 1.5H2.25Zm0 7.5a.75.75 0 0 1 0-1.5h19.5a.75.75 0 0 1 0 1.5H2.25Zm0 7.5a.75.75 0 0 1 0-1.5h19.5a.75.75 0 0 1 0 1.5H2.25Zm0 7.5a.75.75 0 0 1 0-1.5h13.5a.75.75 0 0 1 0 1.5H2.25Z"
    clipRule="evenodd"
  />,
  'Description'
);
